import React, { useRef, useEffect } from "react";
import CustomButton from "./CustomButton";

import lottie from "lottie-web";
import successAnim from "../assets/success.json";

const SuccessPage = () => {
  const animRef = useRef(null);

  useEffect(() => {
    lottie.loadAnimation({
      container: animRef.current,
      renderer: "svg",
      loop: false,
      autoplay: true,
      animationData: successAnim,
    });
  }, []);

  return (
    <>
      <div className="page">
        <div ref={animRef} className="lottie-anim" />
        <p>Success</p>
      </div>
      <div className="footer">
        <CustomButton onClick={() => window.history.back()} text="Go back" />
      </div>
    </>
  );
};

export default SuccessPage;
